import { BasicsClass } from "@/common/BasicsClass";
import { Util } from "@/common/util";

import { CommonApi } from "../common";

export  class CoachPreviewStatisticAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getCoachPreviewStatisticTableList', {
        url: '/admin/trainer/clickList',
        name: 'list',
        label: '列表'
    }],

])
  // 助教点击报告列表
  public getCoachPreviewStatisticTableList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getCoachPreviewStatisticTableList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }


}
